import { gql } from "@apollo/client";
import {MEDIA_FIELDS, SHAPE_FIELDS, TRANSLATED_STRING_FIELDS} from "./common"

export const SYMBOL_FIELDS = gql`
${TRANSLATED_STRING_FIELDS}
${SHAPE_FIELDS}
${MEDIA_FIELDS}
fragment SymbolFields on Symbol {
    id
    boundingShape {...ShapeFields}
    title  {...TranslatedStringFields}
    description {...TranslatedStringFields}
    media {...MediaFields}
    isPublishable
    hasMediaValid
  }`

export const SYMBOL_ASSET_FIELDS = gql`
${SYMBOL_FIELDS}
fragment SymbolAssetFields on SymbolAsset {
    id
    ownerPartyId
    public
    symbol {...SymbolFields}
    createdAt
    updatedAt
  
    isPublishable
    hasMediaValid
  }`
  
  export const SYMBOL_COLLECTION_FIELDS = gql`
  ${TRANSLATED_STRING_FIELDS}
  fragment SymbolCollectionFields on SymbolCollection {
    id
    ownerPartyId
    public
    title {...TranslatedStringFields}
    description {...TranslatedStringFields}
    symbols
    createdAt
    updatedAt
  }`
  